export default __webpack_public_path__ + "static/media/Snd4.67bdbe70.mp3";